function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M12.411 4l2.599 5.267 5.813.845-4.206 4.099L17.61 20l-5.199-2.733L7.213 20l.993-5.789L4 10.112l5.812-.845z" /></svg>;
});


// WEBPACK FOOTER //
// ./src/components/Icon/icons/star.icon.svg